export default __webpack_public_path__ + "static/media/mail-sp.3cc63eb8.png";